export default "__VITE_ASSET__Bm3qQ$AR__"